import { createAction, props } from '@ngrx/store';
import { Subscription } from '../../models';

export const loadCurrentSubscriptionSuccess = createAction(
  '[Load CurrentSubscription Effects] Load CurrentSubscription Success',
  props<{ subscription: Subscription }>()
);
export const loadCurrentSubscriptionError = createAction(
  '[Load CurrentSubscription Effects] Load CurrentSubscription Error',
  props<{ error: unknown }>()
);
export const checkoutSucceeded = createAction(
  '[Checkout Success] Checkout Succeeded',
  props<{ session_id: string }>()
);
export const checkoutSessionError = createAction(
  '[Load CurrentSubscription Effects] Checkout Session Error',
  props<{ error: unknown }>()
);
